import React, { useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "./Dashboard";
import TrainersTable from "./TrainersTable";
import StudentsTable from "./StudentsTable";
import SystemsTable from "./SystemsTable";
import Login from "./Login";
import TrainersCardDetail from "./TrainersCardDetail";
import SystemsCardDetail from "./SystemsCardDetail";
import StudentsCardDetail from "./StudentsCardDetail";
import "./App.css"; // Assuming you have a styles.css for global styles

function App() {
  const [user, setUser] = useState(null);
  const [selectedSchoolName, setSelectedSchoolName] = useState([]);

  const handleLoginSuccess = loggedInUser => {
    setUser(loggedInUser);
    setSelectedSchoolName([]);
  };

  const handleLogout = () => {
    setUser(null);
    setSelectedSchoolName([]);
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            user
              ? <Dashboard
                user={user}
                selectedSchoolName={selectedSchoolName}
                onSchoolChange={setSelectedSchoolName}
                onLogout={handleLogout}
              />
              : <Navigate to="/login" replace />
          }
        />
        <Route
          path="/trainers"
          element={
            user
              ? <TrainersTable user={user} selectedSchoolName={selectedSchoolName} onLogout={handleLogout} />
              : <Navigate to="/login" replace />
          }
        />
        <Route
          path="/students"
          element={
            user
              ? <StudentsTable user={user} selectedSchoolName={selectedSchoolName} onLogout={handleLogout} />
              : <Navigate to="/login" replace />
          }
        />
        <Route
          path="/systems"
          element={
            user
              ? <SystemsTable user={user} selectedSchoolName={selectedSchoolName} onLogout={handleLogout} />
              : <Navigate to="/login" replace />
          }
        />
        <Route
          path="/login"
          element={<Login onLoginSuccess={handleLoginSuccess} />}
        />
        <Route
          path="/trainers/:type"
          element={
            user
              ? <TrainersCardDetail user={user} selectedSchoolName={selectedSchoolName} onLogout={handleLogout} />
              : <Navigate to="/login" replace />
          }
        />
        <Route
          path="/systems/:type"
          element={
            user
              ? <SystemsCardDetail user={user} selectedSchoolName={selectedSchoolName} onLogout={handleLogout} />
              : <Navigate to="/login" replace />
          }
        />
        <Route
          path="/students/:type"
          element={
            user
              ? <StudentsCardDetail user={user} selectedSchoolName={selectedSchoolName} onLogout={handleLogout} />
              : <Navigate to="/login" replace />
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;